const userUrls = {
    getRequestUser: {
        url: '/users/actions/viewer'
    },
    getAuthLogins: {
        url: '/auth/logins'
    },
    getUsers:{
      url:'/users'
    },
    getUser: {
        url: '/users/:id'
    },
    getUserQuestions:{
        url:'/users/:id/questions'
    },
    fetchUserFormOptions: {
        url: '/users/actions/formOptions'
    },
};

export default userUrls;
